import { render } from "./admin-dispatch.vue?vue&type=template&id=74b0baa2&scoped=true"
import script from "./admin-dispatch.vue?vue&type=script&lang=js"
export * from "./admin-dispatch.vue?vue&type=script&lang=js"

import "./admin-dispatch.vue?vue&type=style&index=0&id=74b0baa2&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b0baa2"]])

export default __exports__